<template>
  <v-list class="pt-0" dense>
    <v-list-tile class="board-title">
      <h4 v-if="!mini">&nbsp;&nbsp;{{type == 1 ? 'Individuais' : 'Compartilhadas'}}</h4>
      <h4 v-else>&nbsp;{{type == 1 ? 'Indiv...' : 'Comp...'}}</h4>
      <v-spacer></v-spacer>
      <v-btn round flat small color="primary" style="margin:0;" @click="openInsertDialog(type != 1)">Adicionar</v-btn>
      <!-- <v-tooltip bottom v-else>
        <v-icon slot="activator" color="grey" style="padding-left: 12px;">{{type == 1 ? 'person' : 'group'}}</v-icon>
        <span>{{type == 1 ? 'Individuais' : 'Compartilhadas'}}</span>
      </v-tooltip> -->
    </v-list-tile>
    <draggable id="outer" :value="boards" @input="changeOrderBoard" v-bind="dragOptions" :draggable="type == 1 ? '.item-board-individual' : '.item-board-shared'" handle=".handle" class="list_container">
      <v-hover v-for="board in boards" :key="board.id">
        <v-list-tile
          :key="board.id"
          slot-scope="{ hover }"
          :class="type == 1 ? 'item-board-individual' : 'item-board-shared'"
          :style="`background-color:${(board.id === selectedBoard['id'] || hover) ? '#b1defd8c' : ''}`"
        >
          <v-list-tile-avatar @click="selectBoard(board)" style="cursor: pointer; min-width: 40px;">
            <v-tooltip right>
              <v-avatar v-if="board.team_id" slot="activator" size="25" :color="board.team.color || 'grey'">
                <span class="white--text"> {{ board.team_id ? getFirstLetters(board.team.id_text) : '' }} </span>
                <div class="board-origin" v-if="board.company_id !== $auth.user().company_id">
                  <v-tooltip top>
                    <v-avatar v-if="board.company.logo_path" slot="activator" size="17px">
                      <img :src="`${basePath}uploads/companies/${board.company.logo_path}`" alt="">
                    </v-avatar>
                    <v-avatar v-else slot="activator" size="17px" class="avatar">
                      <span class="avatar-letters"> {{ getFirstLetters(((board.company_id !== $auth.user().company_id) && board.company) ? board.company.id_text : '') }} </span>
                    </v-avatar>
                    <span> {{ ((board.company_id !== $auth.user().company_id) && board.company) ? board.company.id_text : '' }} </span>
                  </v-tooltip>
                </div>
              </v-avatar>
              <v-avatar v-else slot="activator" size="25" :class="board.id === selectedBoard['id'] ? 'board-circle-selected' : 'board-circle'">
                <span v-if="mini">{{getFirstLetters(board.id_text)}}</span>
                <v-icon v-else :color="board.id === selectedBoard['id'] ? 'blue' : 'grey'">person</v-icon>
              </v-avatar>
              <span v-if="mini">{{board.id_text}}</span>
              <span v-else>{{board.team_id ? board.team['id_text'] : 'Individual'}}</span>
            </v-tooltip>
          </v-list-tile-avatar>
          <v-list-tile-content style="cursor: pointer;" @click="selectBoard(board)" v-if="!mini" class="handle">
            <v-list-tile-title>
              <span :style="`padding-left:7px; color:${board.id === selectedBoard['id'] ? 'blue' : 'black'}`">{{board.id_text}}</span>
            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action v-if="!mini && board.id === selectedBoard['id']">
            <v-tooltip v-if="board.id === selectedBoard['id']" bottom>
              <v-layout slot="activator" align-center justify-end >
                <v-btn icon class="mr-2" @click="editItem()" :disabled="!selectedBoard['hasPermission']">
                  <v-icon color="teal">build</v-icon>
                </v-btn>
              </v-layout>
              <span>{{editText}}</span>
            </v-tooltip>
          </v-list-tile-action>
          <v-list-tile-action v-else-if="!mini && hover">
            <v-tooltip bottom>
              <v-flex slot="activator" style="cursor: grab;" class="handle text-xs-right mr-1">
                <v-icon >view_week</v-icon>
              </v-flex>
              <span>Mover</span>
            </v-tooltip>
          </v-list-tile-action>
        </v-list-tile>
      </v-hover>
    </draggable>
  </v-list>
</template>
<script>
  import general from './../../mixin/general'
  import draggable from 'vuedraggable'
  /* eslint-disable eqeqeq */
  export default {
    mixins: [general],
    components: {draggable},
    props: {
      boards: {
        type: Array,
        default: () => { return [] }
      },
      selectedBoard: {
        type: Object,
        default: () => { return {} }
      },
      editText: {
        type: String,
        default: 'Editar'
      },
      mini: {
        type: Boolean,
        default: false
      },
      // type 1 - individual, 2 - compartilhado
      type: {
        type: Number,
        default: 1
      }
    },
    data: () => ({
      dragOptions: {},
      basePath: process.env.API
      // drawer: true,
    }),
    created () {
      this.dragOptions = { animation: 200, group: this.type == 1 ? 'board-individual' : 'board-shared', disabled: false }
    },
    methods: {
      changeOrderBoard (items) {
        console.log('items', items)
        this.$emit('changeOrderBoard', items, this.type)
      },
      // changeOrderBoard () {
      //   this.$emit('changeOrderBoard')
      // },
      selectBoard (board) {
        this.$emit('selectBoard', JSON.parse(JSON.stringify(board)))
      },
      editItem () {
        this.$emit('editItem')
      },
      openInsertDialog (shareTeam) {
        this.$emit('openInsertDialog', shareTeam)
      }
    }
  }
</script>

<style>
/* style Não possui o scoped pois manipula classes que se for scoped não funciona */
  .board-circle-selected {
    font-weight: 600;
    border: 2px solid #0097ff;
    border-radius: 50%; 
	}
  
  .board-circle {
    font-weight: 600;;
    border: 2px solid grey;
    border-radius: 50%; 
	}

/*  Coloca o z-index 203 pois ele estava ficando acima do editar */
 .modal_task_status_id_class, .modal_task_category_id_class {
   z-index: 205 !important;
 }
  /* Para caber a seta para contrair e expandir  tira o pading do titulo, também é tira*/
 .board-title .v-list__tile {
    height: 30px !important;
    padding-left: 0px;
    padding-right: 0px;
 }

  /* Em cada item estava sobrando muito pouco espaço */
 .item-board-individual .v-list__tile {
    padding-left: 0px;
    padding-right: 0px;
 }
 .item-board-shared .v-list__tile {
    padding-left: 0px;
    padding-right: 0px;
 }
 .board-origin{
    position: absolute;
    top: -10px;
    left: 15px;
    border-radius: 50%;
    border: 1px solid #00F260;
    background: #fff;
    color: #333;
  }
</style>




// WEBPACK FOOTER //
// src/components/shared/PTaskBoardList.vue